<template>
  <div class="videojs">
    <div class="video-inner-container">
      <video id="vid1" controls preload="auto" class="video-js vjs-fluid vjs-default-skin vjs-big-play-centered" data-setup="{}">
        <source :src="src" :type="type" />
      </video>
    </div>
  </div>
</template>
<script>
export default {
  name: "VideoJS",
  props: ["title", "src", "type", "videoFile"],
  mounted() {
    var vid = document.getElementById("vid1");
    var this_pointer = this;
    vid.onloadedmetadata = () => {
      let dur = 0;
      if (parseInt(vid.duration)) {
        dur = vid.duration;
      } else if (parseInt(this.videoFile.duration)) {
        dur = this.videoFile.duration;
      }
      console.log(dur)
      this_pointer.$emit("selected-video-duration", dur);
    };
    window.addEventListener(
      "message",
      (event) => {
        if (event.origin === "http://localhost:8100" || event.origin === "https://vkstg.larkbase.com" || event.origin === "https://app.vouchkick.com") {
          if (event.data.settings) {
            for (let key in event.data.settings) {
              this.response.settings[key] = event.data.settings[key];
            }
            this.$session.set("response", this.response);
            var this_pointer = this;
            setTimeout(function() {
              this_pointer.$helpers.resizeIframeEvent();
            }, 300);
          }
        }
      },
      false
    );
  },
};
</script>
<style scoped lang="scss">
.videojs {
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-inner-container {
  max-height: 278px;
  height: auto;
  width: auto;
  border-radius: 5px;
  min-height: 278px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .videoPlayer-dimensions.vjs-fluid {
    padding-top: 0;
  }
}
.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  width: auto;
  max-width: 100%;
  height: 278px !important;
  border-radius: 5px;
  overflow: hidden;

  .vjs-tech {
    position: initial;
    // width: auto;  // Cut the video from corner sides
    height: 100%;
  }

  .vjs-control-bar {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3em;
    background-color: rgba(43, 51, 63, 0.7);
  }
}
</style>
